import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_6 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.6 Case 6</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_6"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 6. This is a positive case.
                Beginning in the temporo-occipital region, seen here, white
                matter tracts are not delineated in the left temporal, right
                temporal, or right occipital region. Increased activity is seen
                in the cortical gray matter, extending to the cortical rim,
                resulting in loss of gray-white contrast.
              </p>
              <p>
                In the left occipital region, however, there is further decrease
                in gray-white contrast. In addition, white matter tracts are not
                delineated. This finding, which is likely due to brain injury,
                can be confirmed by utilizing the accompanying PET-CT scan, and
                in fact, in this case, cystic changes are observed in this
                region, likely from an old stroke. The loss of gray-white
                contrast, seen here, is secondary to decreased activity in the
                white and gray matter and not due to increased activity in the
                gray matter alone.
              </p>
              <p>
                Moving upwards and into the frontal and parietal regions, white
                matter tracts are not delineated in the frontal regions
                bilaterally. There is loss of gray-white contrast, and white
                matter tracts are not seen coursing from the front of the brain
                to the back of the brain on the left-hand side. On the
                right-hand side, as we continue moving upwards, there is a large
                area of decreased tracer activity involving the gray and white
                matter, seen here.
              </p>
              <p>
                Once again, it is important to utilize the fused images to
                evaluate this region. As can be seen, cystic changes are
                observed, and in the pericystic region, there is also loss of
                gray-white contrast. These findings are likely secondary to an
                old stroke. Similar to the left occipital abnormality, loss of
                gray-white contrast is due to decreased activity in the gray and
                white matter. Posterior to this, there is also loss of
                gray-white contrast; however, this is due to increased activity
                in the gray matter alone.
              </p>
              <p>
                As we continue moving upwards and enter into the medial parietal
                region, including the precuneus, increased activity is seen in
                the midline. The remainder of the parietal region also shows
                loss of gray-white contrast.
              </p>
              <p>
                This scan is positive, as there is loss of gray-white contrast,
                specifically due to an increase in activity in the gray matter
                in the frontal, parietal, temporal, and right occipital regions.
                Abnormalities seen in the left occipital and right frontal
                parietal regions are secondary to the presence of old strokes.
                If you called this case negative, you may want to review the
                case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-5"
          nextLesson="/module-4/module-4-1-7"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1912971522&entry_id=1_zqccus6o&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_zqccus6o"
        />
      </main>
    </div>
  );
};

export default Module_4_1_6;
